var exports = {
  "AS": "item__hSosLv",
  "Kk": "icon__petVYe",
  "Pf": "label__YOY2FN",
  "h_": "description__pm0c7B",
};

module.exports = exports;
